export const railwayTransportConst = {
  path: "/single-programs/railway-transport",
  title: "ТРАНСПОРТНЫЙ ФАКУЛЬТЕТ – ЖЕЛЕЗНОДОРОЖНЫЙ ТРАНСПОРТ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Железнодорожный транспорт — стабильность, скорость и стратегия</h2>
      <p>
        Эта программа готовит инженеров и специалистов по организации железнодорожных перевозок. Студенты изучают устройство железнодорожной
        инфраструктуры, логистику грузовых и пассажирских перевозок, технологии эксплуатации и обслуживания подвижного состава.
      </p>
      <p>Программа сочетает глубокие технические знания и управленческие навыки в области железнодорожной отрасли.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Техническая эксплуатация железных дорог</li>
        <li>Устройство пути и железнодорожных сооружений</li>
        <li>Подвижной состав и его обслуживание</li>
        <li>Системы сигнализации и безопасности</li>
        <li>Организация перевозочного процесса</li>
        <li>Транспортная логистика и управление потоками</li>
        <li>Экономика и право железнодорожного транспорта</li>
        <li>Цифровизация и автоматизация управления</li>
      </ul>
      <p>
        Обучение включает практику на железнодорожных объектах, моделирование перевозок и работу с цифровыми системами управления движением.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Инженер-путеец</li>
        <li>Специалист по логистике и транспортным схемам</li>
        <li>Организатор и диспетчер перевозок</li>
        <li>Инженер по подвижному составу</li>
        <li>Эксперт по безопасности движения</li>
        <li>Руководитель железнодорожного участка или станции</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €85,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Диплом, признанный в ЕС и странах СНГ</li>
        <li>Обучение очно или дистанционно</li>
        <li>Преподаватели — специалисты с опытом работы на транспорте</li>
        <li>Практика в транспортных компаниях и на станциях</li>
        <li>Курсы на русском или английском языке</li>
        <li>Поддержка приемной комиссии от первого шага до зачисления</li>
      </ul>
      <p>Транспорт, который движет экономику</p>
      <p>
        Наши выпускники обеспечивают стабильную работу железных дорог, внедряют инновации в логистику и работают в крупнейших транспортных
        компаниях Европы.
      </p>
      <br />
      <p className="padding-left">
        «Железная дорога — это система, где важна каждая секунда. Мы обучаем управлять этой системой профессионально.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам выбрать программу, собрать документы и пройти процедуру поступления без стресса.</p>
    </>
  ),
  contentSearch: `
  Диплом: бакалавра / магистра
  Формы обучения: очно или дистанционно
  Форма связи: Получить консультацию приемной комиссии
  Железнодорожный транспорт — стабильность, скорость и стратегия
  Эта программа готовит инженеров и специалистов по организации железнодорожных перевозок. Студенты изучают устройство железнодорожной инфраструктуры, логистику грузовых и пассажирских перевозок, технологии эксплуатации и обслуживания подвижного состава.
  Программа сочетает глубокие технические знания и управленческие навыки в области железнодорожной отрасли.
  Что вы будете изучать?
  • Техническая эксплуатация железных дорог
  • Устройство пути и железнодорожных сооружений
  • Подвижной состав и его обслуживание
  • Системы сигнализации и безопасности
  • Организация перевозочного процесса
  • Транспортная логистика и управление потоками
  • Экономика и право железнодорожного транспорта
  • Цифровизация и автоматизация управления
  Обучение включает практику на железнодорожных объектах, моделирование перевозок и работу с цифровыми системами управления движением.
  Кем можно работать после окончания?
  • Инженер-путеец
  • Специалист по логистике и транспортным схемам
  • Организатор и диспетчер перевозок
  • Инженер по подвижному составу
  • Эксперт по безопасности движения
  • Руководитель железнодорожного участка или станции
  Зарплата в Европе: от €45,000 до €85,000 в год
  Почему выбирают нас?
  • Диплом, признанный в ЕС и странах СНГ
  • Обучение очно или дистанционно
  • Преподаватели — специалисты с опытом работы на транспорте
  • Практика в транспортных компаниях и на станциях
  • Курсы на русском или английском языке
  • Поддержка приемной комиссии от первого шага до зачисления
  Транспорт, который движет экономику
  Наши выпускники обеспечивают стабильную работу железных дорог, внедряют инновации в логистику и работают в крупнейших транспортных компаниях Европы.
  «Железная дорога — это система, где важна каждая секунда. Мы обучаем управлять этой системой профессионально.»

  Как поступить?
  Приёмная комиссия поможет вам выбрать программу, собрать документы и пройти процедуру поступления без стресса.
  `,
};
